import React, { useEffect, useRef, useState } from "react"
import { Header } from "../shared"
import { ISearchEsProduct, searchEsProduct } from '../../api'
import { useAsync, useQuery } from "../../utils"
import { PharmacyDetailModel, PharmacyModel, ProductModel } from "../../models"
import usePharmacy from "../../hooks/pharmacy"
import Search, { useSearch } from "../shared/Search"
import { useHistory } from "react-router"

const SearchProduct = React.memo(() => {
    const history = useHistory()
    const query = useQuery()
    const productSearchValue = query.get('productSearchValue')

    const search = useSearch()

    const { getCurrentDetailPharmacy } = usePharmacy()
    const getCurrentDetailPharmacyAsync = useAsync<PharmacyDetailModel>(getCurrentDetailPharmacy)
    const searchProductAsync = useAsync(searchEsProduct)

    const [state, setState] = useState<{
        from: number,
        size: number,
        listProduct: Array<ProductModel>,
        outOfData: boolean,
        total?: number,
    }>({
        from: 0,
        size: 10,
        listProduct: [],
        outOfData: false,
        total: 0,
    })

    useEffect(() => {
        getCurrentDetailPharmacyAsync.execute()
    }, [])

    useEffect(() => {
        if (!productSearchValue) return

        search.setValue(productSearchValue)
        search.show()
    }, [productSearchValue])

    const getQuery = ({ search, from, size }: ISearchEsProduct) => {
        return {
			from: from,
			size: size,
			_source: ["id", "name", "imageUrls", "pageUrl"],
			query: {
				bool: {
					must: [
						{
							match: {
								name: {
									query: search,
									minimum_should_match: 2,
									prefix_length: 2,
									fuzziness: "AUTO",
								},
							},
						},
					],
					should: [
						{
							match: {
								name: search,
							},
						},
						{
							match: {
								"name.shingles": {
									query: search,
								},
							},
						},
						{
							match: {
								Ten_tren_hop: {
									query: search,
								},
							},
						},
						{
							match: {
								"Ten_tren_hop.shingles": {
									query: search,
								},
							},
						},
						{
							match_phrase: {
								name: {
									query: search,
									slop: 2,
									boost: 2,
								},
							},
						},
					],
				},
			},
		};
    }

    const resetState = () => {
        setState({
            from: 0,
            size: 10,
            listProduct: [],
            outOfData: false,
            total: 0
        })
    }

    const handleSeach = (value: string) => {
        if (value === '') {
            resetState()
            return
        }

        const params = {
            from: state.from,
            size: state.size,
            search: value,
        }
        searchProductAsync.execute(getQuery(params)).then(res => {
            setState(prev => ({
                ...prev,
                from: 0,
                listProduct: res.data,
                total: res.total,
                outOfData: res.data.length === 0
            }))
        })
    }

    const onScrollHitBottom = () => {
        if (state.outOfData) return
        const params = {
            from: state.from + 10,
            size: state.size,
            search: search.getValue(),
        }

        searchProductAsync.execute(getQuery(params)).then(res => {
            setState(prev => ({
                ...prev,
                from: prev.from + 10,
                listProduct: [...prev.listProduct, ...res.data],
                total: res.total,
                outOfData: res.data.length < 10
            }))
        })
    }

    return <div className='w-100'>
        <Header
            title="Tìm kiếm sản phẩm"
            subTitle={getCurrentDetailPharmacyAsync.value?.pharmacy?.mName}
            backTo="/inventory-dashboard?tab=inventories"
        />
        <div id="main">
            <div className="container" >
                <Search
                    register={search}
                    placeholder='Tìm kiếm sản phẩm'
                    onClear={resetState}
                    debounceTime={100}
                    onSearch={handleSeach}
                    onScrollHitBottom={onScrollHitBottom}
                    data={state.listProduct}
                    loading={searchProductAsync.status === "loading"}
                    dropdownData={(listProduct: Array<ProductModel>, onSelect: () => void) => {
                        return listProduct.map((product: ProductModel, index) => {
                            return <li key={product._id} onClick={() => {
                                history.push(`/update-product?productId=${product._id}`)
                                onSelect()
                            }}>
                                <a style={{ display: "flex" }}>
                                    <img src={product.imageUrls ? (product.imageUrls[0] ? product.imageUrls[0] : './images/default-medicine.png') : './images/default-medicine.png'} alt="Ảnh thuốc" width={45} height={45} style={{ objectFit: 'contain' }} />
                                    <div className="ml-1">
                                        <strong>{product.name}</strong><br />
                                    </div>
                                    <small className="txt-gray"></small>
                                </a>
                            </li>
                        })
                    }}
                />
            </div>
        </div>
    </div>
})

export default SearchProduct